/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import moment from 'moment';
import { Map } from 'immutable';

// import intl from '../mixins/intl';
// import Message from '../components/formatters/Message';

import '../styles/ProjectCardSummary.css';

export default
class AccountCardSummary extends PureComponent {
  static propTypes = {
    description: PropTypes.string,
    counts: PropTypes.instanceOf(Map),
    createdAt: PropTypes.string,
  };

  render() {
    const {
      counts,
    } = this.props;

    const createdAt = (this.props.createdAt)
      ? moment(this.props.createdAt).format('MMM DD, YYYY')
      : 'N/A';
    const projectCount = counts.getIn(['projects'], null);

    return (
      <div className="project-details">
        <ul className="list-group">
          {/*
          <li className="d-flex align-items-center list-group-item justify-content-between project-description">
            <p>
              {description}
            </p>
          </li>
          */}
          <li className="d-flex align-items-center list-group-item justify-content-between">
            Projects
            <span className="badge badge-pill badge-secondary">{projectCount}</span>
          </li>
          {/*
          <li className="d-flex align-items-center list-group-item justify-content-between">
            Elements
            <span className="badge badge-pill badge-secondary">{elementCount}</span>
          </li>
          <li className="d-flex align-items-center list-group-item justify-content-between">
            Element Types
            <span className="badge badge-pill badge-secondary">{elementTypeCount}</span>
          </li>
          */}
          <li className="d-flex align-items-center list-group-item justify-content-between">
            Creation Date
            <span className="badge badge-pill badge-secondary">{createdAt}</span>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AccountCardSummary.js